module.exports = __webpack_public_path__ + "static/img/A-TFapple.d922ead.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/A-TFapple.png
// module id = KTUV
// module chunks = 1